import BaseBusinessAPI from '../portal/baseBusinessAPI'

class StudentPoliciesAPI extends BaseBusinessAPI {
  controllerName = 'StudentPolicys';

  /**
   * Lấy ra tất cả bản ghi theo có filter
   * @param {*} payload
   * @returns
   */
  getAll (payload) {
    const request = {
      url: this.getAPIUrl('all-policy'),
      data: payload,
    }

    return this.getAsync(request)
  }
}

export default new StudentPoliciesAPI()
